export enum ResetPasswordFormFields {
    Email = 'email',
    Password = 'password',
    PasswordConfirmation = 'passwordConfirmation'
}